import { useCallback, useState } from 'react';
import { useFormData } from '../../../utils/formReducer';
import { FORM_ACTIONS } from '../../../utils/formActions';

interface AffiliateSelection {
  utm_source: string;
  name: string;
}

export const useHealthPlanForm = () => {
  const { state: formData, dispatch } = useFormData();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<string>('');

  const clearAffiliate = useCallback(() => {
    dispatch({
      type: FORM_ACTIONS.UPDATE_FORM_FIELD,
      fieldName: 'selected_affiliate',
      payload: null,
    });

    dispatch({
      type: FORM_ACTIONS.UPDATE_FORM_FIELD,
      fieldName: 'affiliate_name',
      payload: '',
    });
  }, [dispatch]);

  const updateAffiliate = useCallback(
    (value: string | null) => {
      dispatch({
        type: FORM_ACTIONS.UPDATE_FORM_FIELD,
        fieldName: 'selected_affiliate',
        payload: value,
      });
    },
    [dispatch]
  );

  const setAffiliateName = useCallback(
    (value: string) => {
      dispatch({
        type: FORM_ACTIONS.UPDATE_FORM_FIELD,
        fieldName: 'affiliate_name',
        payload: value,
      });
    },
    [dispatch]
  );

  const updateReferrer = useCallback(
    (value) => {
      dispatch({
        type: FORM_ACTIONS.UPDATE_FORM_FIELD,
        fieldName: 'referrer',
        payload: value,
      });
    },
    [dispatch]
  );

  const handleAffilSelection = (selection: AffiliateSelection) => {
    updateAffiliate(selection.utm_source);
    setAffiliateName(selection.name);
  };

  return {
    formData,
    isLoading,
    error,
    setError,
    setIsLoading,
    updateAffiliate,
    setAffiliateName,
    clearAffiliate,
    handleAffilSelection,
    updateReferrer,
  };
};
